<template>
  <div class="strength_section">
    <!-- <the-slider></the-slider> -->
    <the-skills></the-skills>
  </div>
</template>
<script>
//import TheSlider from "@/components/strengths/slider/TheSlider";
import TheSkills from "@/components/strengths/skills/TheSkills";

export default {
  components: {TheSkills}
}
</script>

<style scoped>
.strength_section {
  width: 100%;
  min-height: 100vh;
  background-color: white;
  padding-top: 3rem;
}
</style>